import { TWIN_FEEDBACK_OPERATIONS } from "./operations/twin-feedback.js";
export const TWIN_QUERY_OPERATIONS = {
    createQuery: { operationId: "twin.query.create", method: "POST", path: "/api/twin/queries", rateClass: "create", requiredScope: "twin.query", mcpTool: "twin_query" },
    getQuery: { operationId: "twin.query.get", method: "GET", path: "/api/twin/queries/{queryId}", rateClass: "read", requiredScope: "twin.read", mcpTool: "twin_query_result" },
    ...TWIN_FEEDBACK_OPERATIONS,
};
